export interface FlockRecord {
  id: string;
  flockNumber: string;
  flockName: string;
  birdType: string;
  breed: string;
  purpose: string;
  farm: string;
  house: string;
  supplier: string;
  arrivalDate: string;
  initialQty: number;
  currentQty: number;
  ageDays: number;
  mortalityPct: number;
  fcr: number;
  avgWeightKg: number;
  costPerChick: number;
  totalAcquisitionCost: number;
  expectedCycleDays: number;
  targetMarketDate: string;
  status: string;
  survivalRate: number;
}

// Backend: GET /api/flocks
export const MOCK_FLOCKS: FlockRecord[] = [
  {
    id: 'flock-001',
    flockNumber: 'BR-2026-001',
    flockName: 'Batch A1 — Cobb 500',
    birdType: 'Broiler',
    breed: 'Cobb 500',
    purpose: 'Meat',
    farm: 'Idudi Poultry Farm',
    house: 'House A1',
    supplier: 'Ugachick Hatchery',
    arrivalDate: '04/07/2026',
    initialQty: 5000,
    currentQty: 4812,
    ageDays: 62,
    mortalityPct: 3.76,
    fcr: 1.84,
    avgWeightKg: 2.41,
    costPerChick: 2800,
    totalAcquisitionCost: 14000000,
    expectedCycleDays: 42,
    targetMarketDate: '15/08/2026',
    status: 'completed',
    survivalRate: 96.24,
  },
  {
    id: 'flock-002',
    flockNumber: 'BR-2026-002',
    flockName: 'Batch A2 — Ross 308',
    birdType: 'Broiler',
    breed: 'Ross 308',
    purpose: 'Meat',
    farm: 'Idudi Poultry Farm',
    house: 'House A2',
    supplier: 'Ugachick Hatchery',
    arrivalDate: '22/07/2026',
    initialQty: 4800,
    currentQty: 4614,
    ageDays: 44,
    mortalityPct: 3.88,
    fcr: 1.92,
    avgWeightKg: 1.82,
    costPerChick: 2800,
    totalAcquisitionCost: 13440000,
    expectedCycleDays: 42,
    targetMarketDate: '02/09/2026',
    status: 'active',
    survivalRate: 96.12,
  },
  {
    id: 'flock-003',
    flockNumber: 'BR-2026-003',
    flockName: 'Batch B1 — Cobb 500',
    birdType: 'Broiler',
    breed: 'Cobb 500',
    purpose: 'Meat',
    farm: 'Idudi Poultry Farm',
    house: 'House B1',
    supplier: 'Kenchic Uganda',
    arrivalDate: '10/08/2026',
    initialQty: 3500,
    currentQty: 3432,
    ageDays: 25,
    mortalityPct: 1.94,
    fcr: 1.41,
    avgWeightKg: 0.74,
    costPerChick: 3000,
    totalAcquisitionCost: 10500000,
    expectedCycleDays: 42,
    targetMarketDate: '21/09/2026',
    status: 'active',
    survivalRate: 98.06,
  },
  {
    id: 'flock-004',
    flockNumber: 'LY-2026-001',
    flockName: 'Layers Batch L1 — Lohmann',
    birdType: 'Layer',
    breed: 'Lohmann Brown',
    purpose: 'Eggs',
    farm: 'Idudi Poultry Farm',
    house: 'Layer House 01',
    supplier: 'Ugachick Hatchery',
    arrivalDate: '15/01/2026',
    initialQty: 8000,
    currentQty: 7742,
    ageDays: 232,
    mortalityPct: 3.23,
    fcr: 2.18,
    avgWeightKg: 1.92,
    costPerChick: 4500,
    totalAcquisitionCost: 36000000,
    expectedCycleDays: 365,
    targetMarketDate: '15/01/2027',
    status: 'active',
    survivalRate: 96.77,
  },
  {
    id: 'flock-005',
    flockNumber: 'LY-2026-002',
    flockName: 'Layers Batch L2 — Isa Brown',
    birdType: 'Layer',
    breed: 'ISA Brown',
    purpose: 'Eggs',
    farm: 'Idudi Poultry Farm',
    house: 'Layer House 02',
    supplier: 'Kenchic Uganda',
    arrivalDate: '20/02/2026',
    initialQty: 6500,
    currentQty: 6318,
    ageDays: 196,
    mortalityPct: 2.80,
    fcr: 2.22,
    avgWeightKg: 1.88,
    costPerChick: 4500,
    totalAcquisitionCost: 29250000,
    expectedCycleDays: 365,
    targetMarketDate: '20/02/2027',
    status: 'active',
    survivalRate: 97.20,
  },
  {
    id: 'flock-006',
    flockNumber: 'LY-2026-003',
    flockName: 'Layers Batch L3 — Lohmann',
    birdType: 'Layer',
    breed: 'Lohmann Brown',
    purpose: 'Eggs',
    farm: 'Kampala Demo Farm',
    house: 'Layer House 03',
    supplier: 'Ugachick Hatchery',
    arrivalDate: '01/06/2026',
    initialQty: 4000,
    currentQty: 3940,
    ageDays: 95,
    mortalityPct: 1.50,
    fcr: 2.05,
    avgWeightKg: 1.44,
    costPerChick: 4800,
    totalAcquisitionCost: 19200000,
    expectedCycleDays: 365,
    targetMarketDate: '01/06/2027',
    status: 'active',
    survivalRate: 98.50,
  },
  {
    id: 'flock-007',
    flockNumber: 'BRD-2026-001',
    flockName: 'Breeders Flock BD1 — Ross',
    birdType: 'Breeder',
    breed: 'Ross Breeder',
    purpose: 'Hatching Eggs',
    farm: 'Idudi Poultry Farm',
    house: 'Breeder House 01',
    supplier: 'Ugachick Hatchery',
    arrivalDate: '10/03/2026',
    initialQty: 2400,
    currentQty: 2358,
    ageDays: 178,
    mortalityPct: 1.75,
    fcr: 2.44,
    avgWeightKg: 3.12,
    costPerChick: 12000,
    totalAcquisitionCost: 28800000,
    expectedCycleDays: 365,
    targetMarketDate: '10/03/2027',
    status: 'active',
    survivalRate: 98.25,
  },
  {
    id: 'flock-008',
    flockNumber: 'BR-2026-004',
    flockName: 'Batch C1 — Arbor Acres',
    birdType: 'Broiler',
    breed: 'Arbor Acres',
    purpose: 'Meat',
    farm: 'Kampala Demo Farm',
    house: 'House C1',
    supplier: 'Kenchic Uganda',
    arrivalDate: '15/08/2026',
    initialQty: 6000,
    currentQty: 5974,
    ageDays: 20,
    mortalityPct: 0.43,
    fcr: 1.28,
    avgWeightKg: 0.48,
    costPerChick: 2900,
    totalAcquisitionCost: 17400000,
    expectedCycleDays: 42,
    targetMarketDate: '26/09/2026',
    status: 'active',
    survivalRate: 99.57,
  },
  {
    id: 'flock-009',
    flockNumber: 'LOCAL-2026-001',
    flockName: 'Local Kienyeji Batch 01',
    birdType: 'Local/Indigenous',
    breed: 'Kienyeji',
    purpose: 'Meat & Eggs',
    farm: 'Idudi Poultry Farm',
    house: 'Free Range Area',
    supplier: 'Local Farmers',
    arrivalDate: '01/04/2026',
    initialQty: 800,
    currentQty: 762,
    ageDays: 156,
    mortalityPct: 4.75,
    fcr: 3.10,
    avgWeightKg: 1.24,
    costPerChick: 8000,
    totalAcquisitionCost: 6400000,
    expectedCycleDays: 180,
    targetMarketDate: '28/09/2026',
    status: 'active',
    survivalRate: 95.25,
  },
  {
    id: 'flock-010',
    flockNumber: 'BR-2025-018',
    flockName: 'Batch X18 — Cobb 500',
    birdType: 'Broiler',
    breed: 'Cobb 500',
    purpose: 'Meat',
    farm: 'Idudi Poultry Farm',
    house: 'House A1',
    supplier: 'Ugachick Hatchery',
    arrivalDate: '10/05/2025',
    initialQty: 5000,
    currentQty: 0,
    ageDays: 480,
    mortalityPct: 2.80,
    fcr: 1.79,
    avgWeightKg: 2.38,
    costPerChick: 2600,
    totalAcquisitionCost: 13000000,
    expectedCycleDays: 42,
    targetMarketDate: '21/06/2025',
    status: 'sold',
    survivalRate: 97.20,
  },
  {
    id: 'flock-011',
    flockNumber: 'BR-2026-005',
    flockName: 'Batch D2 — Ross 308',
    birdType: 'Broiler',
    breed: 'Ross 308',
    purpose: 'Meat',
    farm: 'Kampala Demo Farm',
    house: 'House D2',
    supplier: 'Kenchic Uganda',
    arrivalDate: '25/08/2026',
    initialQty: 4200,
    currentQty: 4188,
    ageDays: 10,
    mortalityPct: 0.29,
    fcr: 1.12,
    avgWeightKg: 0.24,
    costPerChick: 2900,
    totalAcquisitionCost: 12180000,
    expectedCycleDays: 42,
    targetMarketDate: '06/10/2026',
    status: 'active',
    survivalRate: 99.71,
  },
  {
    id: 'flock-012',
    flockNumber: 'LY-2026-004',
    flockName: 'Layers Batch L4 — Isa Brown',
    birdType: 'Layer',
    breed: 'ISA Brown',
    purpose: 'Eggs',
    farm: 'Kampala Demo Farm',
    house: 'Layer House 04',
    supplier: 'Kenchic Uganda',
    arrivalDate: '01/09/2026',
    initialQty: 5000,
    currentQty: 4996,
    ageDays: 3,
    mortalityPct: 0.08,
    fcr: 0,
    avgWeightKg: 0.06,
    costPerChick: 4800,
    totalAcquisitionCost: 24000000,
    expectedCycleDays: 365,
    targetMarketDate: '01/09/2027',
    status: 'planned',
    survivalRate: 99.92,
  },
  {
    id: 'flock-013',
    flockNumber: 'BR-2026-006',
    flockName: 'Batch E1 — Cobb 500',
    birdType: 'Broiler',
    breed: 'Cobb 500',
    purpose: 'Meat',
    farm: 'Idudi Poultry Farm',
    house: 'House E1',
    supplier: 'Ugachick Hatchery',
    arrivalDate: '28/08/2026',
    initialQty: 3800,
    currentQty: 3794,
    ageDays: 7,
    mortalityPct: 0.16,
    fcr: 1.05,
    avgWeightKg: 0.18,
    costPerChick: 2800,
    totalAcquisitionCost: 10640000,
    expectedCycleDays: 42,
    targetMarketDate: '09/10/2026',
    status: 'active',
    survivalRate: 99.84,
  },
  {
    id: 'flock-014',
    flockNumber: 'BRD-2025-003',
    flockName: 'Breeders Flock BD3 — Cobb',
    birdType: 'Breeder',
    breed: 'Cobb Breeder',
    purpose: 'Hatching Eggs',
    farm: 'Idudi Poultry Farm',
    house: 'Breeder House 02',
    supplier: 'Ugachick Hatchery',
    arrivalDate: '15/06/2025',
    initialQty: 1800,
    currentQty: 0,
    ageDays: 447,
    mortalityPct: 5.11,
    fcr: 2.88,
    avgWeightKg: 3.44,
    costPerChick: 14000,
    totalAcquisitionCost: 25200000,
    expectedCycleDays: 365,
    targetMarketDate: '15/06/2026',
    status: 'closed',
    survivalRate: 94.89,
  },
];